import { styled } from "styled-components";
import { ButtonCentering } from "styles/mixinStyles";

const DeleteButtonContainer = styled(ButtonCentering)`
  position: absolute;
  top: 0;
  right: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
  svg {
    min-width: 1rem;
    min-height: 1rem;
    width: 3vw;
    height: 3vw;
  }
`;

export { DeleteButtonContainer };

